/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../graphql/generated/types';

import { gql } from '@apollo/client';
import { AddressFragmentDoc } from '../Address/Address.hook';
export type LicenseFragment = {
	__typename?: 'License';
	vid_V: string;
	typeValue_VId?: string | null;
	bestStateLicense_V?: boolean | null;
	body_V?: string | null;
	collabAgreeRequired_V?: string | null;
	comprehensivePrescriptiveAuthority_V?: string | null;
	comprehensiveSampleEligibility_V?: string | null;
	ctrlSubstancePrescriptive_V?: string | null;
	ctrlSubstanceSample_V?: string | null;
	deaBusinessActivityCode_V?: string | null;
	deaPaymentIndicator_V?: string | null;
	drugSchedule_V?: string | null;
	expirationDate_V?: any | null;
	gracePeriod_V?: any | null;
	licenseCertification_V?: string | null;
	licenseDegree_V?: string | null;
	licenseEligibility_V?: string | null;
	licenseNumber_V?: string | null;
	licenseStatusCondition_V?: string | null;
	licenseStatus_V?: string | null;
	licenseSubtype_V?: string | null;
	rxaEligible_V?: string | null;
	sourceAddress_V?: string | null;
	type_V?: string | null;
	address?: {
		__typename?: 'Address';
		streetAddress1Cda_V?: string | null;
		streetAddress1Intl_V?: string | null;
		streetAddress2Cda_V?: string | null;
		streetAddress2Intl_V?: string | null;
		postalCodeCda_V?: string | null;
		postalCodeIntl_V?: string | null;
		postalCodeFullUs_V?: string | null;
		cbsa_V?: string | null;
		latitudeCda_V?: number | null;
		longitudeCda_V?: number | null;
		statusCda_V?: string | null;
		statusCda_VId?: string | null;
		subStateAdminUnit_V?: string | null;
		businessCda_V?: boolean | null;
		dpvConfirmedIndicator_V?: string | null;
		buildingIdentifier_V?: string | null;
		phoneCda_V?: string | null;
		faxCda_V?: string | null;
		vid_V: string;
		primaryCda_V?: boolean | null;
		cityCda_V?: string | null;
		cityIntl_V?: string | null;
		stateCda_V?: string | null;
		countryCda_V?: string | null;
		hospitalCampus?:
			| {
					__typename?: 'HCO';
					vid_V: string;
					veevaid_V: string;
					statusCda_V?: string | null;
					statusCda_VId?: string | null;
					hcoNameCda_V?: string | null;
					displayName_V?: string | null;
					hcoNameShort_V?: string | null;
					hcoNameEnglish_V?: string | null;
					hcoNameIntl_V?: string | null;
					hcoTypeCda_V?: string | null;
					addresses: Array<{
						__typename?: 'Address';
						vid_V: string;
						primaryCda_V?: boolean | null;
						cityCda_V?: string | null;
						cityIntl_V?: string | null;
						stateCda_V?: string | null;
						countryCda_V?: string | null;
						streetAddress1Cda_V?: string | null;
						streetAddress1Intl_V?: string | null;
						postalCodeCda_V?: string | null;
						postalCodeIntl_V?: string | null;
					}>;
					hcoType?: { __typename?: 'HCOType'; id: string; name: string } | null;
			  }
			| { __typename?: 'ResourceNotFound'; message: string }
			| null;
	} | null;
};

export const LicenseFragmentDoc = gql`
	fragment License on License {
		vid_V
		typeValue_VId
		bestStateLicense_V
		body_V
		collabAgreeRequired_V
		comprehensivePrescriptiveAuthority_V
		comprehensiveSampleEligibility_V
		ctrlSubstancePrescriptive_V
		ctrlSubstanceSample_V
		deaBusinessActivityCode_V
		deaPaymentIndicator_V
		drugSchedule_V
		expirationDate_V
		gracePeriod_V
		licenseCertification_V
		licenseDegree_V
		licenseEligibility_V
		licenseNumber_V
		licenseStatusCondition_V
		licenseStatus_V
		licenseSubtype_V
		rxaEligible_V
		sourceAddress_V
		type_V
		address {
			...Address
		}
	}
	${AddressFragmentDoc}
`;
